import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { GenaricNotesModule } from '@common/notes/notes.module';
import { ReMultiselectModule } from '@common/re-multiselect/re-multiselect.module';
import { HistoryModule } from '@common/remmi-history/history.module';
import { CommonSharedModule } from '@shared-modules/common-shared.module';
import { PipeDirectiveModule } from '@shared-modules/pipe-directive.module';
import { LibraryMenuModule } from '../../library/private/library-menu/library-menu.module';
import { LibraryViewModeModule } from '../../library/private/library-view-mode/library-view-mode.module';
import { ContractPrimeNgModule } from '../contract-primeNg.module';
import { ContractFormComponent } from './contract-form.component';
import { ReMultipleSelectModule } from '@common/re-multi-select/re-multiselect.module';
import { PriceInputModule } from '@common/price-input/price-input.module';

@NgModule({
  declarations: [ContractFormComponent],
  imports: [
    CommonModule,
    ContractPrimeNgModule,
    CommonSharedModule,
    PipeDirectiveModule,
    LibraryMenuModule,
    LibraryViewModeModule,
    GenaricNotesModule,
    ReMultiselectModule,
    ReMultipleSelectModule,
    HistoryModule,
    PriceInputModule,
  ],
  exports: [ContractFormComponent],
})
export class ContractFormModule {}
